export default "__VITE_ASSET__TZCWFggB__"